<template>
  <span class="text-left">
    <a class="action" @click.stop="showAdd()">
      <i class="fa fa-plus-circle"></i>
    </a>

    <ez-modal v-if="showAddModal" @close="showAddModal = false" size="m-tiny">
      <h3>{{label}}</h3>

      <small class="form-text text-muted">
        <i class="fa fa-info-circle" aria-hidden="true"></i>
        You can either select a {{label.toLowerCase()}} from your {{label.toLowerCase()}}book, or create a new one.
      </small>

      <div class="row">
        <div class="col-2"><input type="radio" v-model="pick" value="a" class="current-item"></div>
        <div class="col-10">
          <under-select2 v-model="addId" :disabled="pick !== 'a'" :options="getOptions" disableAutoSave="true" placeholder="Options">
            Select from {{label}}book
          </under-select2>
        </div>
      </div>

      <div class="row">
        <div class="col-2"><input type="radio" v-model="pick" value="b" class="new-item"></div>
        <div class="col">
          <h5 :class="{ 'disabled': (pick !== 'b')}">New {{label}} <span class="subheader">(Add to {{label}}book)</span></h5>
          <small class="form-text text-muted">This spell will get added to your character and {{label}}book.</small>
        </div>
      </div>

      <div class="row">
        <div class="col-2"><input type="radio" v-model="pick" value="c" class="new-item"></div>
        <div class="col">
          <h5 :class="{ 'disabled': (pick !== 'c')}">New {{label}} <span class="subheader">(Character only)</span></h5>
          <small class="form-text text-muted">This {{label.toLowerCase()}} will <strong>not</strong> get added to your {{label.toLowerCase()}}book.</small>
        </div>
      </div>

      <div class="row">
        <div class="col text-center">
          <button class="btn btn-success" @click.stop="create()">Add</button>
          <button class="btn btn-secondary" @click.stop="showAddModal = false">Cancel</button>
        </div>
      </div>
    </ez-modal>
  </span>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import UnderSelect2 from "../shared/_UnderSelect2.vue";
import modal from "@/mixins/vue-ez-modal";

export default {
  name: "sheet-items-new",
  mixins: [modal],
  components: {
    UnderSelect2
  },
  props: ["section"],
  data() {
    return {
      showAddModal: false,
      addId: null,
      pick: "a"
    };
  },
  watch: {
    showAddModal: "getData"
  },
  computed: {
    ...mapState({
      spellbook: state => state.spells.all,
      ruleset: state => state.session.user.settings.ruleset
    }),
    ...mapGetters({
      canEdit: "characters/canEdit",
      getAll: "spells/getAll",
      getOptions: "spells/getOptions"
    }),
    label() {
      return ["Savage Worlds"].includes(this.ruleset) ? "Power" : "Spell";
    }
  },
  methods: {
    ...mapActions({
      createItem: "characters/createItem",
      spellsAll: "spells/all",
      spellsCreate: "spells/create"
    }),
    showAdd() {
      this.showAddModal = true;
    },
    async getData() {
      if (this.showAddModal) {
        try {
          this.spellsAll({ params: `ruleset=${this.ruleset}&sort=name` });
        } catch (err) {
          console.error(err);
        }
      } else {
        this.addId = null;
        this.pick = "a";
      }
    },
    async create() {
      this.showAddModal = false;

      let _vm = this;
      let payload = { section: this.section, data: { name: this.label } };

      switch (this.pick) {
        case "a":
          if (this.addId) {
            let ref = this.getAll.find(x => x._id === this.addId);
            Object.assign(payload.data, ref);
            payload.data._ref = this.addId;
          }
          break;
        case "b":
          var item = await this.spellsCreate({ ruleset: this.ruleset });
          Object.assign(payload.data, item);
          payload.data._ref = item;
          break;
      }

      try {
        let item = await this.createItem(payload);
        _vm.$rpgv.toggleModal(_vm, `${_vm.section}-${item._id}`);
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/_global";

.add {
  &:hover {
    color: $green !important;
  }
}
a:not([href]):not([tabindex]) {
  color: rgba(255, 255, 255, 0.75);
  &:hover {
    color: $green;
  }
}
small {
  margin-top: -0.5em;
  margin-bottom: 0.25em;
}
.new-item {
  margin-top: 0.25em;
}
.current-item {
  margin-top: 0.4em;
}
.disabled {
  color: rgb(127, 127, 127);
}
</style>
